export default __webpack_public_path__ + "static/media/delivered.bd3f1108.png";